//https://github.com/TheSharpieOne/angular-validation-match
//https://github.com/TheSharpieOne/angular-validation-match/blob/master/src/angular-validation-match.js


module user {
  
  matchValidator.$inject = ['$parse'];
  export function matchValidator($parse: ng.IParseService): ng.IDirective {
    return {
        require: '?ngModel',
        restrict: 'A',
        link: function(scope : ng.IScope, elem: ng.IAugmentedJQuery, attrs: ng.IAttributes, ctrl : ng.INgModelController) {
            if(!ctrl || !attrs['match']) {
                return;
            }

            var matchGetter = $parse(attrs['match']);
            var caselessGetter = $parse(attrs['matchCaseless']);
            var noMatchGetter = $parse(attrs['notMatch']);
            var matchIgnoreEmptyGetter = $parse(attrs['matchIgnoreEmpty']);

            scope.$watch(getMatchValue, function(){
                (<any>ctrl).$$parseAndValidate();
            });

            ctrl.$validators['match'] = function(modelValue, viewValue){
              var matcher = modelValue || viewValue;
              var match = getMatchValue();
              var notMatch = noMatchGetter(scope);
              var value;

              if (matchIgnoreEmptyGetter(scope) && !viewValue) {
                return true;
              }

              if(caselessGetter(scope)){
                value = matcher.toLowerCase() === match.toLowerCase();
              }else{
                value = matcher === match;
              }
              /*jslint bitwise: true */
              value ^= notMatch;
              /*jslint bitwise: false */
              return !!value;
            };

            function getMatchValue(){
                var match = matchGetter(scope);
                if(angular.isObject(match) && match.hasOwnProperty('$viewValue')){
                    match = match.$viewValue;
                }
                return match;
            }
        }
    };
  }
}